import { RouteAnimationShared } from './../../../utils/route-animation-shared';
import { RecipeApiService } from './recipe-api.service';
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { GenericResponse } from '../generic-response';

@Injectable({
  providedIn: 'root',
})
export class RecipeService {
  constructor(
    private location: Location,
    private router: Router,
    private recipeApiService: RecipeApiService,
    private routeAnimationShared: RouteAnimationShared
  ) {}

  back() {
    this.routeAnimationShared.showRouteAnimation();
    this.location.back();
  }

  goToMain() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/main/recipe']);
  }

  goToCategory(categoryId: string, type: string, title: string) {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate([
      '/cookingbook/categorie/' + categoryId + '/' + type + '/' + title,
    ]);
  }
  goToCookingStorySearch() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/cookingbook/search']);
  }
  goToCookingStoryBook() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/cookingbook/book']);
  }
  goToKitchen(type: 'shoppinglist' | 'kitchen') {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['cookingbook/kitchen/' + type]);
  }
  goToHomeMembers() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['cookingbook/members']);
  }
  goToShoppingListSearch() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['cookingbook/kitchen/shoppinglist/search']);
  }
  goToKitchenSearch() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['cookingbook/kitchen/kitchen/search']);
  }
  goToCookingStoryHome() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/cookingbook/book']);
  }
  goTocookingbook() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/main/cookingbook']);
  }
  goToFavorite() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/cookingbook/favorite']);
  }

  goToRecipeDetail(recipeId: string) {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/cookingbook/' + recipeId]);
  }
  goToRecipeTutorial(recipeId: string) {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/cookingbook/' + recipeId + '/tutorial']);
  }

  goToBookmaredRecipes() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/bookmarks']);
  }

  getRecipeCategories(): Promise<GenericResponse> {
    return this.recipeApiService.getRecipeCategories();
  }

  getRecipeCategory(
    categoryId: string,
    page: number,
    limit: number
  ): Promise<GenericResponse> {
    return this.recipeApiService.getRecipeCategory(categoryId, page, limit);
  }

  searchRecipes(
    text: string,
    categoryId: string,
    page: number,
    limit: number
  ): Promise<GenericResponse> {
    return this.recipeApiService.searchRecipes(text, categoryId, page, limit);
  }

  getRecipeDetail(
    recipeId: string,
    storyBook: boolean = false
  ): Promise<GenericResponse> {
    return this.recipeApiService.getRecipeDetail(recipeId, storyBook);
  }

  bookmark(recipeId: string): Promise<GenericResponse> {
    return this.recipeApiService.bookmark(recipeId);
  }

  getBookmarkedRecipes(): Promise<GenericResponse> {
    return this.recipeApiService.getBookmarkedRecipes();
  }
}
